import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import { employee_list_details } from "../../../core/data/json/employees_list_details";
import CommonSelect from "../../../core/common/commonSelect";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import EmpSuccess from "../employees/employeeSuccess";
import "../employees/index.css";
import { createNewPlan, getAllPlans } from "../../../apis/plans";
import moment, { Moment } from "moment";
import { successAlert } from "../../../style/scss/utils/Alerts";
import Newloader from "../employees/loader";
import { formatDate } from "../../../environment";
import * as XLSX from "xlsx";

const PlansList = () => {
  const initialValues = {
    plan_name: "",
    amount: "",
    subscribe_amount: "",
  };
  const initialJsonData = {
    total_financer: "",
    total_staff: "",
    total_retailer: "",
    total_retailer_sales_team: "",
  };
  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;

  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [formData, setFormData] = useState(initialValues);
  const [jsonData, setJsonData] = useState(initialJsonData);
  const { plan_name, amount, subscribe_amount } = formData;
  const {
    total_financer,
    total_staff,
    total_retailer,
    total_retailer_sales_team,
  } = jsonData;
  const handleDateChange = (date: any, dateString: string | string[]) => {
    if (typeof dateString === "string") {
      setSelectedDate(dateString);
    } else if (Array.isArray(dateString)) {
      console.error("Selected Dates:", dateString.join(", "));
    }
  };
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleOnChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setJsonData({ ...jsonData, [name]: value });
  };
  type EmployeeResponse = {
    discription: any;
    plan_name: string;
    Image: string;
    CurrentRole: string;
    amount: number;
    subscribe_amount: number;
    Designation: string;
    joining_date: string;
    Status: string;
    id: any;
    createdAt: string;
  };

  type EmployeeData = {
    key: number;
    Name: string;
    amount: string;
    subscribe_amount: string;
    id: any;
    Status: string;
    createdAt: string;
  };
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(allEmployeeData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Plans");
    XLSX.writeFile(workbook, "Plan List.xlsx");
  };
  const [loader, setLoader] = useState(false);
  const fetchAllEmployees = async () => {
    setLoader(true);
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
      };
      const response = await getAllPlans(data);
      const employeeData = response?.data?.map(
        (item: EmployeeResponse, i: number) => ({
          key: `${i + 1}`,
          id: item.id,
          createdAt: formatDate(item.createdAt),
          Name: `${item.plan_name}`,
          discription: item.discription,
          amount: item.amount || "--",
          subscribe_amount: item.subscribe_amount || "--",
          // Status: item.Status || "--",
        })
      );
      setEmployeeData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoader(false);
    }
  };
  const handleChangeStatus = (data: { id: any; status: string }) => {
    console.error("Status change data:", data);
  };

  useEffect(() => {
    fetchAllEmployees();
  }, [state]);

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "key",
      render: (_: any, record: EmployeeData) => <div>{record.key}</div>,
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (_: any, record: EmployeeData) => <div>{record.createdAt}</div>,
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div>{record.Name}</div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div>{record.amount}</div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.amount.localeCompare(b.amount),
    },
    {
      title: "Subscriber Amount",
      dataIndex: "subscribe_amount",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div>{record.subscribe_amount}</div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.subscribe_amount.localeCompare(b.subscribe_amount),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: () => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#add_employee"
          >
            <i className="ti ti-edit" />
          </Link>
        </div>
      ),
    },
  ];
  const handleSubmit = async (event: any) => {
    setLoader(true);
    event.preventDefault();
    const payload = {
      joining_date: selectedDate,
      status: "active",
      discription: jsonData,
      plan_name: plan_name,
      amount: Number(amount),
      subscribe_amount: Number(subscribe_amount),
    };
    try {
      const response = await createNewPlan(payload);
      if (response.status === true) {
        successAlert("Success", "successfully new plan created");
        setFormData(initialValues);
        setJsonData(initialJsonData);
        setSuccessCreation(true);
        fetchAllEmployees();
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
    // action={all_routes.employeeList}
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                {/* <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                  <Link
                    to={all_routes.branchList}
                    className="btn btn-icon btn-sm active bg-primary text-white me-1"
                  >
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={all_routes.employeeGrid}
                    className="btn btn-icon btn-sm"
                  >
                    <i className="ti ti-layout-grid" />
                  </Link>
                </div> */}
              </div>

              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_employee"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Create New
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div>
                    <label style={{ color: "#000" }}>Search</label>
                    <input
                      type="text"
                      className="form-control form-control-sm me-2"
                      placeholder="Search by Name\Mobile"
                      style={{
                        backgroundColor: "#b4b4b447",
                        padding: "0.2rem 0.85rem",
                        marginTop: "5px",
                      }}
                    />
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {/* <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </Link>
                      </li> */}
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {loader ? (
              <div className="card-body p-0">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    height: "30vh",
                    alignItems: "center",
                  }}
                >
                  <Newloader />
                </div>
              </div>
            ) : (
              <div className="card-body p-0">
                {allEmployeeData && allEmployeeData.length > 0 && (
                  <Table
                    dataSource={allEmployeeData}
                    columns={columns}
                    Selection={true}
                  // rowSelection={{ type: "checkbox" }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        {/* <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2026 © Paybia Finance.</p>
          <p>
            Designed &amp; Developed By{" "}
            <Link to="#" className="text-primary">
              Anjani Creations
            </Link>
          </p>
        </div> */}
      </div>
      {/* /Page Wrapper */}
      {/* Add Employee */}

      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Plans</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form
            // onSubmit={handleSubmit}
            >
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Plan Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="plan_name"
                            value={plan_name}
                            onChange={handleChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Total Financer Access{" "}
                          </label>
                          <input
                            type="number"
                            name="total_financer"
                            value={total_financer}
                            onChange={handleOnChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Total Staff Access{" "}
                          </label>
                          <input
                            type="number"
                            name="total_staff"
                            value={total_staff}
                            onChange={handleOnChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Total Branches Access{" "}
                          </label>
                          <input
                            type="number"
                            name="total_retailer"
                            value={total_retailer}
                            onChange={handleOnChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Total Branches Team Access{" "}
                          </label>
                          <input
                            type="number"
                            name="total_retailer_sales_team"
                            value={total_retailer_sales_team}
                            onChange={handleOnChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            name="amount"
                            value={amount}
                            onChange={handleChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Subscribe Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            name="subscribe_amount"
                            value={subscribe_amount}
                            onChange={handleChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      {/* <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">type</label>
                          <CommonSelect
                            className="select"
                            options={department}
                            defaultValue={department[0]}
                          />
                        </div>
                      </div> */}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      // type="submit"
                      onClick={handleSubmit}
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* /Add Employee */}
      {/* Edit Employee */}

      {/* /Edit Employee */}
      {/* Add Employee Success */}
      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default PlansList;
